import { render, staticRenderFns } from "./ProductMatrixCell.vue?vue&type=template&id=0b852f69&scoped=true&"
import script from "./ProductMatrixCell.vue?vue&type=script&lang=js&"
export * from "./ProductMatrixCell.vue?vue&type=script&lang=js&"
import style0 from "./ProductMatrixCell.vue?vue&type=style&index=0&id=0b852f69&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b852f69",
  null
  
)

export default component.exports